module.exports = __webpack_public_path__ + "img/20200515_161923.01a0b34f.jpg";